import { Injectable } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ConfirmDeleteComponent } from '../../ui-ndms/components/modals/confirm-delete/confirm-delete.component';

@Injectable()
export class NdmsConfirmService {

  public bsModalRef: BsModalRef;

  constructor(
    private modalService: BsModalService,
  ) { }

  delete(msg, cb){
    this.bsModalRef = this.modalService.show(ConfirmDeleteComponent, { ignoreBackdropClick: true });
    this.bsModalRef.content.msg = msg || 'this item';

    this.bsModalRef.content.complete.subscribe(result =>{

      this.bsModalRef.hide();

      if (result === 'yes')  cb()
    })
  }

}
